import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "isExternal", "iconLeft", "iconRight", "iconProps", "id", "url", "mode", "size", "isDisabled", "isMonochrome", "onClick", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import Icon from '../Icon';
import { prefix } from '../../tools/settings';
import { StyledLink } from './Link.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Link = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      _ref$isExternal = _ref.isExternal,
      isExternal = _ref$isExternal === void 0 ? false : _ref$isExternal,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      iconProps = _ref.iconProps,
      id = _ref.id,
      url = _ref.url,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isMonochrome = _ref.isMonochrome,
      isMonochrome = _ref$isMonochrome === void 0 ? false : _ref$isMonochrome,
      onClick = _ref.onClick,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-link"), true), _defineProperty(_cx, "".concat(prefix, "-link--disabled"), isDisabled), _defineProperty(_cx, "".concat(prefix, "-link--monochrome"), isMonochrome), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var externalProps = isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : null;
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsxs(StyledLink, _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      className: className,
      "aria-disabled": isDisabled,
      href: url,
      onClick: onClick
    }, externalProps), rest), {}, {
      children: [iconLeft && _jsx("span", {
        className: "".concat(prefix, "-link__icon ").concat(prefix, "-link__icon--left"),
        children: _jsx(Icon, _objectSpread({
          icon: iconLeft,
          size: 14
        }, iconProps))
      }), _jsx("span", {
        className: "".concat(prefix, "-link__label"),
        children: children
      }), iconRight && _jsx("span", {
        className: "".concat(prefix, "-link__icon ").concat(prefix, "-link__icon--right"),
        children: _jsx(Icon, {
          icon: iconRight,
          size: 14
        })
      })]
    }))
  });
});
export default Link;